import openPopup from '@scripts/modules/Popup'

let videoProduct = `
	<video controls autoplay playsinline width="1280" height="720">
		<source src="libs/video/video_pro_ppe.webm" type="video/webm">
		<source src="libs/video/video_pro_ppe.mp4" type="video/mp4">
	</video>
`

let options = {
	popup: '#video',
	open: '.btn_video',
	close: '#video .ui-close',
	overlay: '#video .ui-overlay',
	whereInsert: '#video-wrap',
	frame: videoProduct
}

new openPopup(options)
